import { hydrate } from '@conekta/cronos/client';
import { ViewState } from 'app/pages/hosted-checkout/interface';
import { EmbeddedCheckout } from 'app/pages/hosted-checkout/views/Checkout/EmbeddedCheckout';

hydrate((state: ViewState) => <EmbeddedCheckout {...state} />);
